import React, { useState,useEffect } from 'react';
  import Menu from "../Menu";
  import Header from '../Header';
  import { Select } from 'antd';
  import { DatePicker } from 'antd';
  import { useSelector, useDispatch } from 'react-redux';
  import { UpdateAuditorContractMappingInfo, AuditorList, doGetAuditorContractList, getAssetDetails, apiCallStatus } from './actions/auditorService';
  import { Link } from 'react-router-dom'
  import Cookie from 'js-cookie';
  import MessageBox from '../../UIComponents/MessageBox/MessageBox';
  import Spinner from '../../UIComponents/Spinner/Spinner';
  import LZString from 'lz-string';
import dayjs from 'dayjs';
  const { Option } = Select;
  
const  AuditorContractMappingEdit = (props) => {
  const {Editdata}=props;
  const jsonData = Cookie.get('currentUser');
            let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
  const user = JSON.parse(decompressedData)
  const userID = user['userId'];

  const auditorContractList = useSelector(state => state?.auditorList?.AuditorContractDetails)
  const [isSubmit, setIsSubmit] = useState(false)
  const [storeImage, setStoreImage] = useState("");
  const [storeImageName, setStoreImageName] = useState("");
  const [mobileNumber, setMobileNumber] =useState(Editdata.mobile_number1); 
  const [email, setEmail] = useState(Editdata.email_address1);
  const [projectScopes, setProjectScopes] = useState([]);
  const apiInfo = useSelector(state => state?.auditorList)
  const auditorList = useSelector(state => state?.auditorList?.AuditorContractDetails?.AuditorList);
  const existingContracts = useSelector(state => state?.auditorList?.AuditorContractDetails?.ExistingContracts)
  const assetDetails = useSelector(state => state?.auditorList?.AssetDetails)
  const [newExistingContracts,setNewExistingContracts] = useState([])
  const [id, setStoreId] = useState('')
  const [auditorListData, setAuditorList] = useState([])
  const [dateRange,setDateRange]= useState([]);
  const [selectAllStore,setAllStore] = useState(false);
  const dispatch = useDispatch()
  const [form, setState] = useState({
    id: Editdata.id,
    auditorId:  Editdata?.auditorId,
    auditorName:  Editdata?.auditorName,
    contractStartDate: Editdata?.contractStartDate,
    contractEndDate: Editdata?.contractEndDate,
    auditorcontractmapbase64:'',
    contractFileName: '',
    storeNames: Editdata?.storeNames,
    auditorStatus: Editdata?.auditorStatus,
    projectScopes: Editdata?.projectScopes

  })
  useEffect(() => {
    selectAuditor(Editdata?.auditorId)
    handleDateSelect(Editdata?.auditorId);
  }, [])

  const selectAuditor = (value) => {
    let filteredData = auditorContractList?.AuditorList?.filter(ele => ele.id == value) //id refers to auditor id
    setProjectScopes(filteredData[0]?.projectScopesId?.split(',').map((id, index)=> {
      return {
        "projectScopesId": id,
        "projectScope": filteredData[0]?.projectScopes.split(',')[index]
      }
    })); //remove duplicates and setProjectScopes
    console.log(projectScopes)
    setMobileNumber(filteredData[0]?.mobileNumber1)
    setEmail(filteredData[0]?.emailAddress1)  
  }
  
  const handleDateSelect = (data) => {
    const dateArray = [];
    console.log("auditorDetail",auditorList);
    console.log("auditor",data);
    auditorList.map((ele) =>{
      if(ele.id === data){
        console.log("ele",ele.id);
        const contractMapInfo =  ele.auditorContractMappingInfos;
        contractMapInfo.map((contract)=>{
          if(contract.auditorId === data){
            const startDate = dayjs(contract.contractStartDate).format('YYYY-MM-DD');
            const endDate = dayjs(contract.contractEndDate).format('YYYY-MM-DD');
            dateArray.push({
              startDate: startDate, // Convert date strings to Date objects
              endDate: endDate
            });
            setDateRange(dateArray);
            console.log(dateArray);
          }
        })
      }
    })
  };

  const setSelectedStoreFile = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      setStoreImageName(file.name);
      let encoded = setStoreImage(reader.result.toString().replace(/^data:(.*,)?/, ''))
    }
    reader.onerror = error => console.log(error)
  }
  const doSubmit = () => {
    setIsSubmit(true);
    if(!form.id) return;
    else if (form.contractStartDate == '') return;
    else if (form.contractEndDate == '') return;
    else if (storeImage == '') return;
    else if (form.storeNames == '') return;
    else if (!form.projectScopes.length) return;
    form.projectScopes = form.projectScopes;
    form.contractFileName = storeImageName;
    form.auditorcontractmapbase64 = storeImage;
    form.auditorStatus = form.storeNames?.length ?1:0;
    //CAUTION: this code will working only when Store Names are uniques as store names are mapped back to ids while submit
    //map storeNames back to ids
    let tempStoreIds = auditorContractList?.StoreList.map((store)=> {
      return form.storeNames.map((storeName)=> {
        if(storeName == store.storeName)
          return store.storeId
      })
    })
    form.storeIds = tempStoreIds.flat().filter(item => item != undefined).join();
    //CAUTION: same as above
    let tempProjectScopesIds = auditorContractList?.ProjectScopes.map((projectScope)=> {
      return form?.projectScopes?.map((projectScopeName)=> {
        if(projectScopeName == projectScope.name)
          return projectScope.id
      })
    })
    form.projectScopes = tempProjectScopesIds.flat().filter(item => item != undefined).join();
    //Convert the contract date to appropriate format
    form.contractStartDate = dayjs(new Date(form.contractStartDate)).format("YYYY-MM-DD");
    form.contractEndDate = dayjs(new Date(form.contractEndDate)).format("YYYY-MM-DD");
    //remove unwanted fields
    delete form?.auditorName;
    delete form.storeNames;
    //removing contract file name as aws not working -> to be included in prod
    // form.contractFileName =""; 
    // form.auditorcontractmapbase64 =""; 
    console.log(form, 'form');
    dispatch(UpdateAuditorContractMappingInfo(form))
  }
  const dataHandler = (value)=>{
    value[0]==="selectAll"?setAllStore(true):setAllStore(false);
    setStoreId(value)
    setAuditorList(auditorContractList?.AuditorList)
    setState({...form})
  }

  function disabledEndDate(current) {
    // Disable dates before today
     if (!current || current.isBefore(Date.now(), 'day')) {
      return true;
      }
      if(form.contractStartDate){
        return current && current < dayjs(form.contractStartDate);
      }
      const dateString = current.format('YYYY-MM-DD');
      return dateRange.some(range => {
      return dateString >= range.startDate && dateString <= range.endDate;
      });
     }

  const CheckIsAuditorExist = () =>{
    if(form.storeNames =="") return;
    if(form.id =="") return;
    let isExist = auditorContractList?.AuditorsContractMappingList.some((item)=> (item.storeId == form.storeNames&& item.id == form.id))
    isExist && dispatch(apiCallStatus({
      message: 'Auditor is already in contract mapping. Kindly Use Edit Operation for Any Contract Changes',
      modalOpen: true,
      loading: false,
      apiStatus:false,
    }));
  }
  return (
    <>
      <Header title={"Edit Auditor Contract Mapping"} />
      <Menu />
      {apiInfo.modalOpen ? (
        <MessageBox
          message={apiInfo.message}
          onClose={() => {
            dispatch(doGetAuditorContractList(userID))
          }
          }
        />
      ) : null}
      <div className='content-wrapper'>
        {apiInfo.loading ? (
          <Spinner />
        ) : (
          <section className='content top-space'>
            <div className="m-panel">
              <div className="m-panel__body">
              <div className="row m-grid">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor='exampleInput'>Auditor*</label>
                        <Select className="form-control"
                          showSearch placeholder="-- Please Select --"
                          optionFilterProp="children"
                          onChange={(value) => (handleDateSelect(value),selectAuditor(value), setState({ ...form, auditorId: value }))}
                          value={form.auditorId}
                          onBlur={()=>{
                            return CheckIsAuditorExist()
                          }}
                          filterOption={(input, option) =>
                            option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                          }                        
                        >{
                            auditorContractList?.AuditorNameList.map(item => (
                              <Option key={item.id} value={item.id}>{item.auditorName}</Option>
                            ))
                          }
                        </Select>
                        {!form.auditorId&& isSubmit == true ? <span className="text-danger">Please Select Auditor</span> : null}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group select_h150">
                        <label htmlFor='exampleInput'>Project Scopes*</label>
                        <Select className="form-control"
                          onChange={(value) => (dataHandler(value),setState({ ...form, projectScopes: value }))}
                          showSearch
                          mode='multiple' 
                          placeholder="-- Please Select --"
                          optionFilterProp="children"
                          value={form.projectScopes}
                          filterOption={(input, option) =>
                            option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          {
                            projectScopes?.map(item => (
                              <Option key={item.projectScopesId} value={item.projectScope} >{item.projectScope}</Option>
                            ))
                          }
                        </Select>
                        {!form.projectScopes?.length && isSubmit == true ? <span className="text-danger">Please Select Scopes</span> : null}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group select_h150">
                        <label htmlFor='exampleInput'>Store*</label>
                        <Select className="form-control"
                          onChange={(value) => {
                            dataHandler(value);
                            value = value.includes("selectAll")?
                              value=auditorContractList?.StoreList?.map((item) => item.storeName):
                              value;
                            value = value.length == auditorContractList?.StoreList?.length && form.storeNames?.length == value.length? []:value// deselect all
                            setState({ ...form, storeNames: value })
                          }}
                          showSearch
                          mode='multiple' 
                          placeholder="-- Please Select --"
                          optionFilterProp="children"
                          value={form.storeNames}
                          filterOption={(input, option) =>
                            option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                          }
                        >
                           {/* Add a "Select All" option */}
                           {<Option key="selectAll">
                             {"Select All"}
                            </Option>}
                          {
                            auditorContractList?.StoreList?.map(item => (
                              selectAllStore ? 
                              <Option key={item.storeId} value={item.storeName} >{item.storeName}</Option> : 
                              <Option key={item.storeId} value={item.storeName} >{item.storeName}</Option>
                          ))
                          }
                        </Select>
                        {form.storeNames == '' && isSubmit == true ? <span className="text-danger">Please Select Store</span> : null}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Auditor mobile number*</label>
                        <input type="text" className="form-control" disabled value={mobileNumber} />
                      </div>
                    </div>


                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Auditor email id*</label>
                        <input type="text" className="form-control" disabled value={email} />
                      </div>
                    </div> 
                    <div className="col-md-4">
                      <div className="form-group">
                        <label style={{display:"flex"}}  htmlFor='exampleInput'>Contract start date*<div style={{width:"1.5rem",height:"1.5rem",backgroundColor:"rgba(0, 0, 0, 0.25)",marginTop:'0.5rem',marginLeft:"0.5rem",marginRight:"0.5rem"}}></div>(Disable dates)</label>
                        <DatePicker className="form-control" defaultValue={dayjs(Editdata?.contractStartDate)}  format={'YYYY-MM-DD'} onChange={(date, dateString) => setState({ ...form, contractStartDate: dateString })} 
                        disabledDate={disabledEndDate}/>
                        {form.contractStartDate == '' && isSubmit == true ? <span className="text-danger">Please Select Contract start date</span> : null}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label style={{display:"flex"}}  htmlFor='exampleInput'>Contract end date*<div style={{width:"1.5rem",height:"1.5rem",backgroundColor:"rgba(0, 0, 0, 0.25)",marginTop:'0.5rem',marginLeft:"0.5rem",marginRight:"0.5rem"}}></div>(Disable dates)</label>
                        <DatePicker className="form-control" defaultValue={dayjs(Editdata?.contractEndDate)}   format={'YYYY-MM-DD'} onChange={(date, dateString) => setState({ ...form, contractEndDate: dateString })} 
                        disabledDate={disabledEndDate} />
                        {form.contractEndDate == '' && isSubmit == true ? <span className="text-danger">Please Select Contract end date</span> : null}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor='exampleInput'>Upload document*</label>
                        <input type="file" className="form-control" onChange={(e) => setSelectedStoreFile(e.target.files[0])} accept={".pdf"}/>
                      </div>
                      {storeImage.trim() == '' && isSubmit == true ? <span className="text-danger">Please Select  File</span> : null}
                    </div>
                  </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 text-right">
                <div className="m-page__button top-space">

                  <Link className="option" to='/AuditorContract'>
                    <button type='button' className='btn muted-button  deca-btn-orange'  onClick={()=>dispatch(AuditorList(true))}>Back</button>
                  </Link>

                  <button type='button' className='btn btn-secondary deca-btn-yellow' onClick={() => doSubmit()}>Submit</button>
                </div>
              </div>
            </div>
          </section>
        )}
      </div>
    </>
  )
}
  
export default AuditorContractMappingEdit;